import { merge } from 'lodash';
import { NEVER } from 'rxjs';

import { Injectable } from '@angular/core';

import { ISnListQueryParameters } from '@lib/api';
import { SnFloor } from '@lib/api/entities';
import { SnFloorsAPI } from '@lib/api/services';
import { ISnFileUploadFormFieldConfigInterface } from '@lib/form/file-upload';
import { ISnHttpSelectFormFieldConfig } from '@lib/form/http-select';
import { ISnInputFormFieldConfig } from '@lib/form/input';
import { t } from '@lib/translation';

@Injectable({ providedIn: 'root' })
export class SnFloorFieldsGeneratorService {
  constructor(private readonly _floorsAPI: SnFloorsAPI) {}

  public getFloorSelectField(
    locationControlName: string = 'location',
    fieldConfig?: Partial<ISnHttpSelectFormFieldConfig<SnFloor>>,
  ): ISnHttpSelectFormFieldConfig<SnFloor> {
    const baseFieldConfig: ISnHttpSelectFormFieldConfig<SnFloor> = {
      key: 'floor',
      type: 'http-select',
      templateOptions: {
        label: t('common.floor'),
        infinityScroll: true,
        valueProp: 'id',
        labelProp: 'name',
        fetchDataFn: (params: ISnListQueryParameters, model: any, field) => {
          const locationId: string = field.parent.formControl.get(locationControlName).value;
          return locationId ? this._floorsAPI.getFloorList(locationId, params) : NEVER;
        },
      },
      expressionProperties: {
        'templateOptions.disabled': (model, formState, field) => {
          const locationId: string = field.parent.formControl.get(locationControlName).value;
          return !locationId;
        },
      },
    };

    return merge(baseFieldConfig, fieldConfig);
  }

  public getNameField(fieldConfig?: Partial<ISnInputFormFieldConfig>): ISnInputFormFieldConfig {
    const baseFieldConfig: ISnInputFormFieldConfig = {
      key: 'name',
      type: 'input',
      templateOptions: {
        label: t('common.name'),
        placeholder: t('common.enterName'),
      },
    };

    return merge(baseFieldConfig, fieldConfig);
  }

  public getFileUploadField(
    fieldConfig?: Partial<ISnFileUploadFormFieldConfigInterface>,
  ): ISnFileUploadFormFieldConfigInterface {
    const baseFieldConfig: ISnFileUploadFormFieldConfigInterface = {
      type: 'file-upload',
      key: 'files',
      templateOptions: {
        multiple: false,
        allowPreview: true,
        allowedContentTypes: [
          'image/jpeg',
          'image/jpg',
          'image/png',
          'image/svg',
          'application/pdf',
        ],
        accept: '.jpg, .jpeg, .png, .svg, .pdf',
      },
    };

    return merge(baseFieldConfig, fieldConfig);
  }
}
